import { Drawer } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  .ant-drawer-body {
    padding: 0px;
    min-height: 100dvh;
  }
  z-index: 9999; // to be sure that the drawer is on top of cance/save buttons in the footer of the mobile forms
`;

export const MenuWrapper = styled.div`
  min-height: 100dvh;
`;

export const StyledDrawer = styled(Drawer).attrs({
  styles: {
    wrapper: {
      width: 'fit-content',
    },
  },
})``;
